module.exports = __webpack_public_path__ + "img/ERP_swiperTab_bg1.a498b2c4.png";